import styled from 'styled-components';
import { req } from '../../@api/request';
import { s } from './pay.style';
import PageTop from '../components/pageTop/PageTop';
import Footer from '../components/footer/Footer';
import Menu from '../components/menu/Menu';
import { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { start } from 'repl';

interface IFormData {
  P_INI_PAYMENT: string;
  P_MID: string;
  P_OID: string;
  P_AMT: number;
  P_GOODS: string;
  P_UNAME: string;
  P_NEXT_URL: string;
  P_RESERVED: string;
  url: string;
  P_NOTI_URL: string;
}

const PaymentMethod = () => {
  const server = new URL(
    process.env.REACT_APP_HOST_API || 'http://localhost:3333/',
  ).origin;

  const [openMenu, setOpenMenu] = useState(false);
  const location = useLocation();
  const { selectedPlan, month } = location.state || {};
  const isDiscount = selectedPlan?.is_discount === 'Y';
  const [formData, setFormData] = useState<IFormData>();
  const formRef = useRef<HTMLFormElement>(null);
  const [data, setData] = useState<any>(null);
  const [paymentType, setPaymentType] = useState<
    'CARD' | 'BANK' | 'VBANK' | ''
  >('');
  const plan_end = localStorage.getItem('plan_end');
  const startDate = plan_end ? new Date(plan_end) : new Date();
  const endDate = new Date(startDate);
  const extraMonth = selectedPlan?.name?.includes('바른NPL') ? 3 : 0;

  if ((month || 1) === 12) {
    endDate.setDate(endDate.getDate() + 365 + 30 * extraMonth);
  } else {
    endDate.setDate(endDate.getDate() + 30 * ((month || 1) + extraMonth));
  }

  // yyyy년 MM월 dd일 형식으로 포맷팅
  const formatDate = (date: Date) => {
    return `${date.getFullYear()}년 ${String(date.getMonth() + 1).padStart(2, '0')}월 ${String(date.getDate()).padStart(2, '0')}일`;
  };

  const formattedStart = formatDate(startDate);
  const formattedEnd = formatDate(endDate);

  const handlePayment = async (paymentType: 'CARD' | 'BANK' | 'VBANK' | '') => {
    if (!selectedPlan.plan_id) {
      alert('결제할 상품을 선택해주세요.');
      return;
    }

    if (!paymentType) {
      alert('결제할 수단을 선택해주세요.');
      return;
    }

    try {
      const res = await req.get(`payment/${selectedPlan.plan_id}`);
      setFormData({
        P_INI_PAYMENT: paymentType,
        P_MID: res.data.data.mid,
        P_OID: res.data.data.oid,
        P_AMT: selectedPlan.plan_prc,
        P_GOODS: res.data.data.goodname,
        P_UNAME: res.data.data.userName,
        P_NEXT_URL: `${server}/payment/auth/phone?front=${window.location.origin}`,
        P_RESERVED: 'centerCd=Y',
        url: 'https://mobile.inicis.com/smart/payment/',
        P_NOTI_URL: `${server}/payment/noti/mobile`,
      });
    } catch (error: any) {
      console.error(error.response.data.message);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (formData && formRef.current) {
      formRef.current.submit();
    }
  }, [formData]);

  return (
    <>
      <PageTop
        logo
        isSearch={false}
        isBackButton={false}
        setOpenMenu={setOpenMenu}
      />
      <s.Container>
        <s.PageTitleDiv>
          <span>결제하기</span>
        </s.PageTitleDiv>
        <PaymentDiv>
          <PaymentDivTitle>결제금액 확인</PaymentDivTitle>
          <PriceDiv>
            <s.Span50016Dark>결제 금액</s.Span50016Dark>
            <s.Span70024>
              {selectedPlan.plan_prc.toLocaleString('ko-KR')}원
            </s.Span70024>
            <s.Span50014Light>{selectedPlan.name}</s.Span50014Light>
          </PriceDiv>
          <PaymentDetailDiv>
            <PaymentDetailRow>
              <s.Div70014>상품 금액</s.Div70014>
              <div>
                <Data isDiscount={isDiscount}>
                  {isDiscount
                    ? `${(selectedPlan.plan_prc * 2).toLocaleString('ko-KR')}원`
                    : `${selectedPlan.plan_prc.toLocaleString('ko-KR')}원`}
                </Data>
              </div>
            </PaymentDetailRow>
            <PaymentDetailRow>
              <s.Div70014>할인 금액</s.Div70014>
              <SaleColumn>
                <Data>
                  {isDiscount
                    ? `-${selectedPlan.plan_prc.toLocaleString('ko-KR')}원`
                    : '0원'}
                </Data>

                {isDiscount && (
                  <Sale>
                    <img
                      src="/assets/images/icon/orange_light_16.svg"
                      alt="할인 아이콘"
                    />
                    <span>
                      {selectedPlan.name.includes('바른NPL')
                        ? '바른NPL 50% 할인'
                        : selectedPlan.name.includes('얼리버드')
                          ? '얼리버드 50% 할인'
                          : '50% 할인'}
                    </span>
                  </Sale>
                )}
              </SaleColumn>
            </PaymentDetailRow>
            <s.GrayLine />
            <PaymentDetailRow>
              <s.Div70014>최종 결제금액</s.Div70014>
              <Data>{selectedPlan.plan_prc.toLocaleString('ko-KR')}원</Data>
            </PaymentDetailRow>
          </PaymentDetailDiv>
          <PaymentDetailDiv>
            <s.Div70014>멤버십 적용기간</s.Div70014>
            <Data>{`${formattedStart} ~ ${formattedEnd}`}</Data>
          </PaymentDetailDiv>
          <s.Span50014Light>
            ※ 현재 무료 체험 중인 이용권이 있는 경우
            <br />
            무료 이용권 사용 종료 후 이용권이 시작됩니다.
          </s.Span50014Light>
          <PaymentMethodDiv>
            <s.Div70014>결제 방법</s.Div70014>
            <PaymentMethodRow>
              <PaymentMethodButton
                selected={paymentType === 'CARD'}
                onClick={() => setPaymentType('CARD')}
              >
                신용카드
              </PaymentMethodButton>

              <PaymentMethodButton
                selected={paymentType === 'BANK'}
                onClick={() => setPaymentType('BANK')}
              >
                계좌이체
              </PaymentMethodButton>

              <PaymentMethodButton
                selected={paymentType === 'VBANK'}
                onClick={() => setPaymentType('VBANK')}
              >
                무통장 입금
              </PaymentMethodButton>
            </PaymentMethodRow>
          </PaymentMethodDiv>
          {/* 다음 버튼 클릭 시 해당 이니시스 페이지로 이동  */}
          <s.Blue100Button onClick={() => handlePayment(paymentType)}>
            다음
          </s.Blue100Button>
        </PaymentDiv>
      </s.Container>
      <Footer />
      {openMenu && <Menu page="/payment/method" setOpenMenu={setOpenMenu} />}
      {formData && (
        <div>
          <form
            method="POST"
            acceptCharset="euc-kr"
            action={formData.url}
            ref={formRef}
            style={{ display: 'none' }}
          >
            {Object.entries(formData).map(([key, value]) => {
              return (
                <input
                  key={key}
                  type="text"
                  name={key}
                  value={value}
                  readOnly
                />
              );
            })}
          </form>
        </div>
      )}
    </>
  );
};

export default PaymentMethod;

const PaymentDiv = styled.div`
  width: 100%;
  border-radius: 20px;
  border: 1px solid #e5e8ea;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`;

const PaymentDivTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222222;
`;

const PriceDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const PaymentDetailDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 20px;
  border-radius: 16px;
  background-color: #f7f9fa;
`;

const PaymentDetailRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Data = styled.div<{ isDiscount?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  color: #222222;
  color: ${({ isDiscount }) => (isDiscount ? '#616161' : '#222222')};
  text-decoration: ${({ isDiscount }) =>
    isDiscount ? 'line-through' : 'none'};
`;

const PaymentMethodDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const PaymentMethodRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const PaymentMethodButton = styled.div<{ selected: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: ${({ selected }) => (selected ? '#222222' : '#616161')};
  border: 1px solid ${({ selected }) => (selected ? '#222222' : '#e5e8ea')};
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  padding: 12px 8px;
  box-sizing: border-box;

  &:hover {
    border: 1px solid #222222;
    color: #222222;
  }
`;

const SaleColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 4px;
`;

const Sale = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: #ff5500;
`;
